import doubleClickZoom from '@mapbox/mapbox-gl-draw/src/lib/double_click_zoom';
import {geojsonTypes, cursors, types, modes, events, updateActions} from '@mapbox/mapbox-gl-draw/src/constants';
import DrawPolygon from '@mapbox/mapbox-gl-draw/src/modes/draw_polygon';
import dragPan from './drag_pan';
import simplify from "@turf/simplify";

const FreeDraw = DrawPolygon;

FreeDraw.onSetup = function() {
    const polygon = this.newFeature({

        type: geojsonTypes.FEATURE,
        properties: {},
        geometry: {
            type: geojsonTypes.POLYGON,
            coordinates: [[]]
        }
    });

    this.addFeature(polygon);

    this.clearSelectedFeatures();
    doubleClickZoom.disable(this);
    dragPan.disable(this);
    this.updateUIClasses({ mouse: cursors.ADD });
    this.activateUIButton(types.POLYGON);
    this.setActionableState({
        trash: true
    });

    return {
        polygon,
        currentVertexPosition: 0,
        dragMoving: false
    };
};

FreeDraw.onDrag = FreeDraw.onTouchMove = function (state, e){
    state.dragMoving = true;
    this.updateUIClasses({ mouse: cursors.ADD });
    state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat);
    state.currentVertexPosition++;
    state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat);
}

FreeDraw.onMouseUp = function (state, e){
    if (state.dragMoving) {
        //var tolerance = 0.00003;
        let tolerance = (1 / ((this.map.getZoom()-3) * 1200)) - 0.00004;
        simplify(state.polygon, {
            mutate: true,
            tolerance: tolerance,
            highQuality: true
        });

        this.fireUpdate();
        this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
    }
}

FreeDraw.onTouchEnd = function(state, e) {
    this.onMouseUp(state, e)
}

FreeDraw.fireUpdate = function() {
    console.log("update");
    this.map.fire(events.UPDATE, {
        action: updateActions.MOVE,
        features: this.getSelected().map(f => f.toGeoJSON())
    });
};

export default FreeDraw
